import GeneralTableComponent from 'components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import { RequestStatus } from 'components/GeneralFormView/types';
import { translate } from 'helperFunctions/translation';
import {
  inject,
  observer,
    useObserver,
  } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PrizeType } from '../DtO/prizeFormViewModel';
import {
  PrizesProps
} from '../types';
  
  const WheelPrizesScreen: React.FC<PrizesProps> = observer(inject('wheelFortuneStore')((props: PrizesProps) => {
    const history = useHistory();
    const { eventId } = useParams<{eventId: string}>();
    const {
      wheelFortuneStore,
    } = props;

    useEffect(() => { onInit() } , []);

    const onInit = async () => {
      await wheelFortuneStore.getWheelPrizes(+eventId);
    }

    const onEditClick = async (index: number, key: string) => {
      try {
        const prize = wheelFortuneStore.prizes[index];
        if(!prize || !prize.prizeId) { return; }
        history.push(`/wheel-fortune/events/${eventId}/prizes/${prize.prizeId}/edit`);
      } catch (error) {
      }
    };

    const addPrizePress = () => {
      history.push(`/wheel-fortune/events/${eventId}/prizes/new`);
    };
  
    const PrizesTable = (props: {state: RequestStatus}) => {
      return(
        <GeneralTableComponent
          emptyMessage={translate('settingsListNoSettingsMessage', {
          })}
          title={'Wheel of fortune prizes'}
          tableHeader={[
            {
              title: "Value"
            },
            {
              title: "Weight"
            },
            {
              title: "max winners"
            },
            {
              title: 'backgroundColor'
            },
            {
              title: "type",
            },
            {
              title: "edit"
            },
          ]}
          tableData={
            wheelFortuneStore.prizes.map(p => {
              return {
                ...p,
                value: p.type === PrizeType.points ? Number(p.value).toLocaleString() : p.value,
                backgroundColor: <div style={{
                  background: `${p.backgroundColor}`,
                  width: '20px',
                  height: '20px'
                }}></div>,
                edit: 'edit',
              }
            })
          }
          tableCellTypes={[
            {
             key: 'value',
             cellType: 'Text' 
            },
            {
              key: 'weight',
              cellType: 'Text' 
            },
            {
              key: 'maxWinners',
              cellType: 'Text'
            },
            {
              key: 'backgroundColor',
              cellType: 'Text'
            },
            {
              key: 'type',
              cellType: 'Text'
            },
            {
              key: 'edit',
              cellType: 'Button',
              onClick: onEditClick,
            },
          ]}
          loadingStatus={[
            props.state
          ]}
          addButton={{
            title: 'Add Prize',
            onAdd: addPrizePress
          }}
      />
      )
    };
    return useObserver(() => (
      <>
      <PrizesTable state={wheelFortuneStore.status} />
      </>
    ));
  }));
  
  export default WheelPrizesScreen;
  